var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(20.005 19.999) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    transform: "translate(0.005 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M11.169,3.091a2.06,2.06,0,0,0-1.027-.5c-1.9.125-4-.165-5.879,0a1.812,1.812,0,0,0-1.545,1.22c-.23,3.956-.046,7.966-.094,11.941A1.841,1.841,0,0,0,4.1,17.394c1.831.266,4.208-.162,6.1.01a1.856,1.856,0,0,0,1.41-1.234,10,10,0,0,1,.181-1.024,1.282,1.282,0,0,1,2.467.545,4.464,4.464,0,0,1-3.76,4.24c-2.006.2-4.473-.141-6.589.006A4.411,4.411,0,0,1,.1,15.993c.212-3.886-.285-8.081,0-11.932A4.385,4.385,0,0,1,3.962.054c2.092.141,4.413-.182,6.477,0A4.456,4.456,0,0,1,14.253,4.3a1.278,1.278,0,0,1-2.495.453c-.19-.648-.024-1.111-.59-1.667Z",
    transform: "translate(-0.005 0.001)",
    fill: "#9180eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M78.088,74.1c-.264-.391-.8-.706-1.008-1.126a1.277,1.277,0,0,1,1.909-1.617c1.092.838,2.114,2.326,3.208,3.224a1.282,1.282,0,0,1,0,1.569c-1.116.918-2.154,2.425-3.269,3.284a1.265,1.265,0,0,1-1.938-1.465c.178-.48.713-.77,1.007-1.157.046-.061.116-.076.09-.182H68.821c-.158,0-.618-.4-.716-.546a1.281,1.281,0,0,1,.452-1.828c.051-.027.363-.157.384-.157h9.146Z",
    transform: "translate(-62.465 -65.37)",
    fill: "#9180eb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/sign-out-icon.8649277155a013d34a1bac6a518b42e8.svg";
export { ForwardRef as ReactComponent };